// #region imports

// --- Angular
import { Directive, TemplateRef } from '@angular/core';

// #endregion

@Directive({
  selector: '[hsEditmode]'
})
export class EditModeDirective {

  constructor(public tplRef: TemplateRef<any>) { }

}
